import { Container, Grid } from "@mui/material"
import styleCss from "../Style/style"
import BusSearchBox from "../HomeLayout/Bus-search-Section"
import BusFilter from "./BusSearchFilters"
import BusSeatsSelection from "./Bus_Seat_Selection"
import { useParams } from "react-router-dom"
import { decryptData } from "../Utilities/crypto"

const BusFound = () => {
    const params = useParams()
    const travelDetail = params;


    return (
        <>
            <Grid sx={styleCss.CommonTopStyle}>
                <Container>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Grid sx={{
                            padding: "20px 20px 30px 24px",
                            borderRadius: "12px",
                            boxShadow: "0 4px 20px 0 rgba(0, 0, 0, 0.05)",
                            borderBottom: "1px solid #f5f5f5",
                            backgroundColor: "#fff",
                            marginBottom: '30px',
                        }}>
                            {/* <BusSearchBox /> */}
                            <BusSearchBox fromDetails={decryptData(travelDetail.fromId)} toDetails={decryptData(travelDetail?.toId)} travelDates={travelDetail?.travelDate} />
                        </Grid>
                    </Grid>
                </Container>
                <Container>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <BusFilter key={`${travelDetail.fromId}-${travelDetail.toId}-${travelDetail.travelDate}`} fromDetails={decryptData(travelDetail.fromId)} toDetails={decryptData(travelDetail?.toId)} travelDates={travelDetail?.travelDate} />
                        </Grid>
                        <Grid size={{ md: 9, xs: 12 }}>
                            <BusSeatsSelection key={`${travelDetail.fromId}-${travelDetail.toId}-${travelDetail.travelDate}`} fromDetails={decryptData(travelDetail.fromId)} toDetails={decryptData(travelDetail?.toId)} travelDates={travelDetail?.travelDate} />
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
        </>
    )
}
export default BusFound;